module.exports = __webpack_public_path__ + "media/src/images/styleguide/summer_01-89c6b24f5426eeff789990b1ff2e692d.svg";